export const getPointerRotatedSize = (data: {
  w: number;
  h: number;
  pivotX?: number;
  pivotY?: number;
}) => {
  const { w = 0, h = 0, pivotX, pivotY } = data;
  const _pivotX = pivotX ?? w / 2;
  const _pivotY = pivotY ?? h / 2;
  // const radius = Math.max(
  //   Math.abs(w - _pivotX),
  //   Math.abs(_pivotX),
  //   Math.abs(h - _pivotY),
  //   Math.abs(_pivotY)
  // );
  const _radius = Math.max(
    Math.sqrt(Math.pow(_pivotX, 2) + Math.pow(_pivotY, 2)),
    Math.sqrt(Math.pow(w - _pivotX, 2) + Math.pow(_pivotY, 2)),
    Math.sqrt(Math.pow(_pivotX, 2) + Math.pow(h - _pivotY, 2)),
    Math.sqrt(Math.pow(w - _pivotX, 2) + Math.pow(h - _pivotY, 2))
  );
  const radius = Math.round(_radius);

  return {
    w: radius * 2,
    h: radius * 2
  };
};
